import { render, staticRenderFns } from "./WaitingForDoctor.vue?vue&type=template&id=e49d4b34&scoped=true&"
import script from "./WaitingForDoctor.vue?vue&type=script&lang=js&"
export * from "./WaitingForDoctor.vue?vue&type=script&lang=js&"
import style0 from "./WaitingForDoctor.vue?vue&type=style&index=0&id=e49d4b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49d4b34",
  null
  
)

export default component.exports